(() => {
    if (customElements.get('predictive-search')) {
      return;
    }
  
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.body = document.querySelector('body');
      this.closeButton = this.querySelector('[data-button-close]');
    }

    connectedCallback() {
      if (this.hasAttribute('disable')) return;
      this.input.addEventListener('input', this.search.bind(this));
      this.input.addEventListener('focus', this.handleFocus.bind(this));
      this.input.addEventListener('blur', this.handleBlur.bind(this));
      if (this.closeButton) {
        this.closeButton.addEventListener('click', this.handleClose.bind(this));
      }
      
      // Backdrop'a tıklandığında aramayı kapat
      document.addEventListener('click', this.handleBackdropClick.bind(this));
      
      this.setOffset();
    }

    handleBackdropClick(event) {
      // Eğer tıklama predictive-search elementinin dışındaysa ve search aktifse kapat
      if (this.body.classList.contains('search-active') && 
          !this.contains(event.target)) {
        this.handleClose();
      }
    }

    handleFocus() {
      if (this.input.value.trim()) {
        this.body.classList.add('search-active');
      }
    }

    handleBlur() {
      // Blur'u geciktiriyoruz ki sonuçlara tıklayabilelim
      setTimeout(() => {
        if (!this.contains(document.activeElement)) {
          this.body.classList.remove('search-active');
        }
      }, 200);
    }

    handleClose() {
      this.body.classList.remove('search-active');
      this.input.value = '';
      this.querySelector('[data-result]').innerHTML = '';
    }
  
      setOffset() {
        const searchWrapper = this.querySelector(
          '[data-predictive-search]'
        );
        const barHeight = document.querySelector(
          'announcement-bar'
        )?.offsetHeight;
        const headerHeight = document.querySelector(
          'header[data-header]'
        )?.offsetHeight;
        const searchFieldHeight = this.querySelector(
          '[data-predictive-search-control]'
        )?.offsetHeight;
  
        const offset = barHeight + headerHeight + searchFieldHeight;
        searchWrapper.style.setProperty('--offset', `${offset}px`);
      }
  
    search() {
      const predictiveSearchSection =
        this.querySelector('[data-result]');
      const terms = this.input.value;

      if (!terms) {
        predictiveSearchSection.innerHTML = '';
        this.body.classList.remove('search-active');
        return;
      }

      fetch(
        window.Shopify.routes.root +
          `search/suggest?q=${terms}&resources[type]=product,article,page,collection,query&section_id=predictive-search`
      )
        .then(response => response.text())
        .then(text => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector(
              '#shopify-section-predictive-search'
            )?.innerHTML;

          if (resultsMarkup == undefined) {
            return;
          }

          predictiveSearchSection.innerHTML = resultsMarkup;
          this.setOffset();
          
          // Sonuçlar göründüğünde backdrop'u aktif et
          if (terms.trim()) {
            this.body.classList.add('search-active');
          }
        });
    }
    }
  
    customElements.define('predictive-search', PredictiveSearch);
  })();
  